import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import axios from 'axios';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AdminDashboard from './components/AdminDashboard';
import MaritimeChainDemo from './components/MaritimeChainDemo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const [companyInfo, setCompanyInfo] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Fetch company info and services on load
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [companyResponse, servicesResponse] = await Promise.all([
          axios.get(`${API}/company-info`),
          axios.get(`${API}/services`)
        ]);
        
        setCompanyInfo(companyResponse.data);
        setServices(servicesResponse.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError('Failed to load data');
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{backgroundColor: 'var(--bg-primary)'}}>
        <div className="text-center">
          <div className="animate-spin w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full mx-auto mb-6"></div>
          <div className="text-xl mb-2" style={{color: 'var(--text-primary)'}}>AquaSage Group</div>
          <div className="text-sm" style={{color: 'var(--text-secondary)'}}>Loading maritime solutions...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{backgroundColor: 'var(--bg-primary)'}}>
        <div className="text-red-600 text-xl">{error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{backgroundColor: 'var(--bg-primary)'}}>
      <Header companyInfo={companyInfo} onContactClick={scrollToContact} />
      <Hero companyInfo={companyInfo} onContactClick={scrollToContact} />
      <Services services={services} />
      <About />
      <Contact />
      <Footer companyInfo={companyInfo} />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/demo" element={<MaritimeChainDemo />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;